import { render } from "./CardNuevoComentario.vue?vue&type=template&id=21a0dc2f"
import script from "./CardNuevoComentario.vue?vue&type=script&lang=js"
export * from "./CardNuevoComentario.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__